import type { IPortalAuthData } from 'components/contentspace/sessionCookie'

interface ISsoStatus {
  authenticated: boolean
  email?: string
  userName?: string | null
  endUserId?: string
}

interface IAutoLoginConfig {
  id: string
}

export interface IAuthGateInputs {
  existingAuth: IPortalAuthData | null
  ssoStatus: ISsoStatus
  autoLoginConfig: IAutoLoginConfig | null
  isAutoLoginBypassed: boolean
}

export type AuthGateAction =
  | { kind: 'keep'; refreshedAuth: ISsoStatus | null }
  | { kind: 'clear-and-redirect-sso'; autoLoginConfigId: string }
  | { kind: 'clear-and-show-gate' }

// Принимает state, говорит AuthGate'у одно из трёх действий. Изолировано
// для тестируемости — компонент только применяет результат, всю логику
// держим тут (см. spec 2026-05-07-portal-stale-cookie-recovery-design).
export const resolveAuthGateAction = ({
  existingAuth,
  ssoStatus,
  autoLoginConfig,
  isAutoLoginBypassed,
}: IAuthGateInputs): AuthGateAction => {
  const claimsSso = !!existingAuth?.ssoAuthenticated

  if (ssoStatus.authenticated) {
    return { kind: 'keep', refreshedAuth: ssoStatus }
  }

  if (!claimsSso) {
    // Анон/non-SSO — false от /sso/me ничего не значит, идём дальше.
    return { kind: 'keep', refreshedAuth: null }
  }

  // Stale-cookie: FE считает, что юзер SSO-залогинен, BE не подтверждает.
  if (autoLoginConfig && !isAutoLoginBypassed) {
    return {
      kind: 'clear-and-redirect-sso',
      autoLoginConfigId: autoLoginConfig.id,
    }
  }
  return { kind: 'clear-and-show-gate' }
}
